export default "__VITE_ASSET__DWO_A1yQ__"